import { ReactNode } from "react"
import { Helmet } from "react-helmet"

interface Props {
  children: ReactNode
}

export const AddToDocumentHead: React.FC<Props> = (props: Props) => {
  const { children } = props
  if (!children) return null
  return <Helmet>{children}</Helmet>
}
